angular.module('tf.controllers')

    .controller('SubscriptionController', function ($scope, HttpService, NotificationService, Session, $state, AuthService, $window,
                                           SessionStorageService, $stateParams, $cookies, $timeout, $rootScope, RecaptchaService, BillingService, HeaderService) {
        var SUBSCRIPTION_LOCAL_STORAGE_KEY = 'tf_subscription_wiz';
        var SUBSCRIPTION_COMPLETED_LOCAL_STORAGE_KEY = 'tf_subscription_comp';
        var INITIAL_STATE = {
            plan : "Basic",
            period : "m",
            billing_address:{
                country : "US",
                state : "AL",
                city:'',
                address:'',
                address_zip:''
            },
            commitment_idx : 1,
            analyticsParams : $stateParams.analytics_params
        };
        $scope.session =  Session;
        $scope.pricing = BillingService.plans;

        HeaderService.setName("Upgrade");

        $scope.onCommitmentChange = function(){
            $scope.selectedCommitment = $scope.pricing.commitment[$scope.commitmentIndex];
        };

        $scope.wizardState = {
            isAuth : AuthService.isAuthenticated(),
            processingPayment : false
        };

        var accessToken = $cookies.get('access_token');
        if(['logged out', 'timed out'].includes(accessToken)){
            $cookies.put('access_token', 'none');
            SessionStorageService.setItem(SUBSCRIPTION_LOCAL_STORAGE_KEY, INITIAL_STATE);
        }

        $scope.subscriptionState = SessionStorageService.getObject(SUBSCRIPTION_LOCAL_STORAGE_KEY) || INITIAL_STATE;
        $scope.commitmentIndex = ($scope.subscriptionState.commitment_idx === '0' || !$scope.subscriptionState.commitment_idx) ? 1 : $scope.subscriptionState.commitment_idx;
        $scope.selectedCommitment = $scope.pricing.commitment[$scope.commitmentIndex];

        function updateFieldsBySelectedSource(){
            if($scope.subscriptionState.source && $scope.subscriptionState.source.name !== 'other') {
                $scope.subscriptionState.billing_address.country = $scope.subscriptionState.source.address_country;
                $scope.subscriptionState.billing_address.city = $scope.subscriptionState.source.address_city;
                $scope.subscriptionState.billing_address.address = $scope.subscriptionState.source.address_line1;
                $scope.subscriptionState.billing_address.address_zip = $scope.subscriptionState.source.address_zip;
                $scope.subscriptionState.billing_address.state = $scope.subscriptionState.source.address_state;
            }else {
                Object.assign($scope.subscriptionState.billing_address, INITIAL_STATE.billing_address);
            }
        }
        function fillKnownUserData(){
            if(!$scope.subscriptionState.billing_address.city) {
                //load saved billing address
                AuthService.getSources().then(function (data) {
                    if (data.sources && data.sources.length > 0) {
                        $scope.subscriptionState.source = _.first(data.sources);
                        updateFieldsBySelectedSource();
                        $scope.subscriptionState.source = _.first(data.sources);
                        $scope.subscriptionState.sources = data.sources;
                        $scope.subscriptionState.sources.push(otherSourceObj);
                    }
                    SessionStorageService.setItem(SUBSCRIPTION_LOCAL_STORAGE_KEY, $scope.subscriptionState);
                });
            }
        }
        $scope.sources = $scope.subscriptionState.sources || [];
        $scope.subscriptionState.source =_.first($scope.sources);
        var otherSourceObj = {
            brand : 'Other',
            name:'other'
        };
        if($state.current.name === 'app.subscribe.pricing'){
            fillKnownUserData();
            if($scope.subscriptionState.period.toLowerCase() === 'content'){
                $scope.subscriptionState.period = INITIAL_STATE.period;
            }
        }else if($state.current.name === 'app.subscribe.payment'){
            $rootScope.$broadcast('working',false);
            $scope.subscriptionState.plan = $stateParams.plan;
            $scope.subscriptionState.period = $stateParams.period;
            $scope.subscriptionState.commitment_idx = $stateParams.c;
            if($scope.subscriptionState.commitment_idx){
                $scope.selectedCommitment = $scope.pricing.commitment[$scope.subscriptionState.commitment_idx];
            }
            if($scope.wizardState.isAuth){
                $scope.subscriptionState.billing_address.company = $scope.subscriptionState.billing_address.company ||  (Session.user && Session.user.local && Session.user.local.company);
            }
            RecaptchaService.renderV3('subscription-recaptcha');
        }else if($state.current.name === 'app.subscribe.processing-payment'){
            //load configuration
            $scope.subscriptionState = SessionStorageService.getObject(SUBSCRIPTION_LOCAL_STORAGE_KEY);
            if($scope.subscriptionState.plan.toLowerCase() === 'payg'){
                $scope.subscriptionState.commitment = 0;
            }else if($scope.subscriptionState.plan.toLowerCase() === 'commitment'){
                $scope.subscriptionState.commitment = $scope.pricing.commitment[$scope.subscriptionState.commitment_idx].renders;
            }else{
                delete $scope.subscriptionState.commitment;
            }
            if($scope.subscriptionState){
                subscribeRegisteredUser();
            }else{
                $state.go('app.subscribe.payment', {
                    plan:$scope.subscriptionState.plan.toLowerCase(),
                    period:$scope.subscriptionState.period.toLowerCase(),
                    analytics_params:$scope.subscriptionState.analyticsParams
                });
            }
        }else if($state.current.name === 'app.subscribe.thanks'){
            var comp = SessionStorageService.getObject(SUBSCRIPTION_COMPLETED_LOCAL_STORAGE_KEY);
            if(!comp){
                $state.go('app.subscribe.pricing',{analytics_params:$scope.subscriptionState.analyticsParams});
            }
        }

        function getPlanFullName(plan){
            switch (plan.toLowerCase()) {
                case 'basic':
                    return 'Basic';
                case 'pro':
                    return 'Pro';
                case 'payg':
                case 'commitment':
                    return 'On Demand';
            }
        }

        function getBillingPeriod(period){
            switch (period.toLowerCase()) {
                case 'm':
                    return 'Monthly';
                case 'y':
                    return 'Annually';
                case 'content':
                    return 'Monthly';
            }
        }

        $scope.getBillingTitle = function(){
            return getPlanFullName($scope.subscriptionState.plan);
        };

        $scope.getBillingSubTitle = function(){
            return getBillingPeriod($scope.subscriptionState.period);
        };

        $scope.changePeriod = function(period){
            $scope.subscriptionState.period = period;
        };

        $scope.back = function () {
            SessionStorageService.setItem(SUBSCRIPTION_LOCAL_STORAGE_KEY, $scope.subscriptionState);
            $state.go('app.subscribe.pricing',{analytics_params:$scope.subscriptionState.analyticsParams});
        };

        $scope.buy = function (plan) {
            $scope.subscriptionState.plan = plan.toLowerCase();
            if($scope.subscriptionState.plan === 'free'){
                //In case we are authorized (already logged in) redirect to main page. Otherwise go to signup
                if($scope.wizardState.isAuth){
                    return window.location.replace("/");
                }else{
                    return $state.go('signup.email',{analytics_params:{initiator:'get started - free plan - subscription'}});
                }
            }else{
                $scope.subscriptionState.commitment_idx = $scope.subscriptionState.plan === 'payg'? 0 : $scope.commitmentIndex;
            }
            $scope.subscriptionState.analyticsParams = $scope.subscriptionState.analyticsParams || {};
            Object.assign($scope.subscriptionState.analyticsParams, $scope.pricing.commitment[$scope.subscriptionState.commitment_idx]);
            SessionStorageService.setItem(SUBSCRIPTION_LOCAL_STORAGE_KEY, $scope.subscriptionState);
            $state.go('app.subscribe.payment', {
                plan:$scope.subscriptionState.plan.toLowerCase(),
                period:$scope.subscriptionState.period.toLowerCase(),
                c :$scope.subscriptionState.commitment_idx,
                analytics_params:$scope.subscriptionState.analyticsParams});
        };

        function subscribeRegisteredUser(){
            $scope.wizardState.processingPayment = true;
            HttpService.post("plan/upgrade", $scope.subscriptionState).then(function (res) {
                    Session.farm = res.data;
                    SessionStorageService.removeItem(SUBSCRIPTION_LOCAL_STORAGE_KEY);
                    SessionStorageService.setItem(SUBSCRIPTION_COMPLETED_LOCAL_STORAGE_KEY,{});
                    $scope.wizardState.processingPayment = false;
                    $rootScope.$broadcast('working',false);
                    if(!$scope.wizardState.isAuth){
                        $cookies.remove('access_token');
                        $cookies.remove('farm_id');
                    }
                    $state.go('app.subscribe.thanks',{analytics_params:$scope.subscriptionState.analyticsParams});
                },
                function (err) {
                    if(!$scope.wizardState.isAuth){
                        $cookies.remove('access_token');
                        $cookies.remove('farm_id');
                    }
                    $scope.state.processingPayment = false;
                    $state.go('app.subscribe.payment', {
                        plan:$scope.subscriptionState.plan.toLowerCase(),
                        period:$scope.subscriptionState.period.toLowerCase(),
                        c :$scope.subscriptionState.commitment_idx,
                        analytics_params:$scope.subscriptionState.analyticsParams});
                    $rootScope.$broadcast('working',false);
                }
            );
        }

        function subscribeNewUser(){
            $scope.wizardState.processingPayment = true;
            //don't redirect in this case
            AuthService.redirectAfterLogin('null');
            $scope.subscriptionState.credentials.confirmPassword = $scope.subscriptionState.credentials.password;
            $scope.subscriptionState.credentials.country = $scope.subscriptionState.billing_address.country;
            //signup the user and the subscribe
            AuthService.signupMultiStep($scope.subscriptionState.credentials).then(function(){
                SessionStorageService.setItem(SUBSCRIPTION_LOCAL_STORAGE_KEY, $scope.subscriptionState);
                $rootScope.$broadcast('working',false);
                $state.go('app.subscribe.processing-payment', {
                    plan:$scope.subscriptionState.plan.toLowerCase(),
                    period:$scope.subscriptionState.period.toLowerCase(),
                    c :$scope.subscriptionState.commitment_idx,
                    analytics_params:$scope.subscriptionState.analyticsParams});
            },function(err){
                $rootScope.$broadcast('working',false);
                $window.scrollTo(0,0);
                console.log(err);
            });
        }
        $scope.subscribe = function () {
            $rootScope.$broadcast('working',true);
            RecaptchaService.execute('subscribe').then(function(token){
                $scope.subscriptionState['g-recaptcha-response'] = token;
                if(!$scope.wizardState.isAuth){
                    $scope.subscriptionState.credentials['g-recaptcha-response'] = token;
                    subscribeNewUser();
                }else{
                    SessionStorageService.setItem(SUBSCRIPTION_LOCAL_STORAGE_KEY, $scope.subscriptionState);
                    $state.go('app.subscribe.processing-payment', {
                        plan:$scope.subscriptionState.plan.toLowerCase(),
                        period:$scope.subscriptionState.period.toLowerCase(),
                        c :$scope.subscriptionState.commitment_idx,
                        analytics_params:$scope.subscriptionState.analyticsParams});
                }
            });

        };

        $scope.countryChanged = function(){
            if( $scope.subscriptionState.billing_address.country !== 'US'){
                $scope.subscriptionState.billing_address.state = '';
            }else{
                $scope.subscriptionState.billing_address.state = 'AL';
            }
        };

        $scope.cardChanged = function(){
            updateFieldsBySelectedSource();
        };

        $scope.isPlanAvailable = function(planId){
            if($scope.wizardState.isAuth){
                var plan = (Session && Session.farm && Session.farm.plan.code) || 0;
                return plan < planId;
            }
            return true;
        };

        function showAlert(alert){
            $timeout(function(){alert.show();},1);
        }
        $rootScope.$on("signup-error", function(event, data){
            showAlert(data);
        });

        $scope.shouldShowPrices = function () {
            return true;
        };

        $scope.calc = {
            renders     : 100,
            period      : '30',
            annual      : '1'
        };

        $scope.calculate = function(){
            var res = $scope.calc.renders * +$scope.calc.period * +$scope.calc.annual;
            var result = "Please fill all fields in the question above";

            if (res<100){
                result = "For a small production, the best plan would be an On Demand plan.";
            }
            return res+result;
        };

        $scope.getOrderPlan = function(){

        };

        $scope.orderSummery = function(){
            var summery = {
                total : '',
                pricePerRender : '',
                renders: '',
            };
            if($scope.subscriptionState.plan === 'payg'){
                summery.total = "$1.5 per render";
                summery.pricePerRender = '';
            } else if($scope.subscriptionState.plan === 'commitment'){
                var plan = $scope.pricing.commitment[$scope.subscriptionState.commitment_idx];
                summery.pricePerRender = plan.price_per_render;
                summery.total = '$' + plan.price;
                summery.renders = plan.renders;
            }
            return summery;
        };
    });